<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <main class="admin-main">
      <div class="bg-info m-b-30">
        <div class="container">
          <div class="row p-b-60 p-t-60">
            <div class="col-md-6 text-center mx-auto text-white p-b-30">
              <div class="m-b-10">
                <div class="avatar">
                  <!-- <div class="avatar-title rounded-circle fe fe-briefcase"></div> -->
                </div>
              </div>
              <p class="h3 text-dark">Create Wallet</p>
            </div>
          </div>
        </div>
      </div>

      <section class="pull-up">
        <div class="container">
          <div class="row list">
            <div class="col-md-12">
              <div class="card m-b-30">
                <div class="card-header"></div>

                <div class="card-body">
                  <div class="text-center"></div>

                  <div class="form-row">
                    <b class="h4">Basic Details</b>
                  </div>

                  <div class="form-row">
                    <div class="form-group col-md-4">
                      <label for="inputEmail4">Company Name</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="provider.agency_name"
                        placeholder="First Name"
                      />
                    </div>
                    <div class="form-group col-md-4">
                      <label for="inputPassword4">First Name</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="provider.firstname"
                        placeholder="Last Name"
                      />
                    </div>

                    <div class="form-group col-md-4">
                      <label for="inputPassword4">Last Name</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="provider.lastname"
                        placeholder="Last Name"
                      />
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label for="inputEmail4">Email</label>
                      <input
                        type="email"
                        class="form-control"
                        v-model="provider.email"
                        placeholder="Email"
                      />
                    </div>

                    <div class="form-group col-md-6">
                      <label for="inputPassword4">Phone Number</label>

                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text" id="inputGroupPrepend3"
                            >+234</span
                          >
                        </div>

                        <input v-phone
                          type="text"
                          class="form-control"
                          placeholder="Phone Number"
                          v-model="provider.phone_number"
                          aria-describedby="inputGroupPrepend3"
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="form-group col-md-6">
                      <label for="inputPassword4">Contact DOB</label>
                      <input
                        type="date"
                        class="form-control"
                        v-model="provider.dob"
                        placeholder="Date of Birth"
                      />
                    </div>

                    <div class="form-group col-md-6">
                      <label for="inputPassword4">Postal Code</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="provider.postalCode"
                        placeholder="Postal Code"
                      />
                    </div>

                  

                    <div class="form-group col-md-12">
                      <label for="inputPassword4">Address Line</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="provider.address1"
                        placeholder="Address"
                      />
                    </div>
                  </div>

                  <div class="form-row">
                    <b class="h4">KYC </b>
                  </div>

                  <div class="row">

                    <div class="form-group col-md-6">
                      <label for="inputCity">Preferred Identification</label>
                      <select
                        class="form-control"
                        v-model="provider.id_type"
                        @change="fetchWards($event)"
                      >
                        <option
                          v-for="identity in identities"
                          v-bind:key="identity"
                          :value="identity"
                        >
                          {{ identity }}
                        </option>
                      </select>
                    </div>

                   

                    <div class="form-group col-md-6">
                      <label for="inputPassword4">Identification Number</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="provider.id_number"
                        placeholder="ID Number"
                      />
                    </div>

                    <div class="form-group col-md-6">
                      <div>
                        <label for="inputPassword4 ">Front of ID Card </label>
                      </div>
                      <div
                        class="fileinput fileinput-new"
                        data-provides="fileinput"
                      >
                        <span class="btn btn-file">
                          <span class="fileinput-new"
                            >upload <i class="fe fe-upload"></i
                          ></span>
                          <span class="fileinput-exists">Change</span>
                          <input
                            type="file"
                            name="..."
                            v-on:change="attachPic"
                          />
                        </span>
                        <span class="fileinput-filename"></span>
                        <a
                          href="#"
                          class="close fileinput-exists"
                          data-dismiss="fileinput"
                          style="float: none"
                          >&times;</a
                        >
                      </div>
                    </div>

                    <div class="form-group col-md-6">
                      <div>
                        <label for="inputPassword4 ">Back of ID Card </label>
                      </div>
                      <div
                        class="fileinput fileinput-new"
                        data-provides="fileinput"
                      >
                        <span class="btn btn-file">
                          <span class="fileinput-new"
                            >upload <i class="fe fe-upload"></i
                          ></span>
                          <span class="fileinput-exists">Change</span>
                          <input
                            type="file"
                            name="..."
                            v-on:change="attachPic"
                          />
                        </span>
                        <span class="fileinput-filename"></span>
                        <a
                          href="#"
                          class="close fileinput-exists"
                          data-dismiss="fileinput"
                          style="float: none"
                          >&times;</a
                        >
                      </div>
                    </div>

                    <div class="form-group col-md-6">
                      <div>
                        <label for="inputPassword4 "
                          >Incoporation Certificate (CAC)</label
                        >
                      </div>
                      <div
                        class="fileinput fileinput-new"
                        data-provides="fileinput"
                      >
                        <span class="btn btn-file">
                          <span class="fileinput-new"
                            >upload <i class="fe fe-upload"></i
                          ></span>
                          <span class="fileinput-exists">Change</span>
                          <input
                            type="file"
                            name="..."
                            v-on:change="attachPic"
                          />
                        </span>
                        <span class="fileinput-filename"></span>
                        <a
                          href="#"
                          class="close fileinput-exists"
                          data-dismiss="fileinput"
                          style="float: none"
                          >&times;</a
                        >
                      </div>
                    </div>

                    <div class="form-group col-md-6">
                      <div>
                        <label for="inputPassword4 "
                          >Proof of Address (Business)</label
                        >
                      </div>
                      <div
                        class="fileinput fileinput-new"
                        data-provides="fileinput"
                      >
                        <span class="btn btn-file">
                          <span class="fileinput-new"
                            >upload <i class="fe fe-upload"></i
                          ></span>
                          <span class="fileinput-exists">Change</span>
                          <input
                            type="file"
                            name="..."
                            v-on:change="attachPic"
                          />
                        </span>
                        <span class="fileinput-filename"></span>
                        <a
                          href="#"
                          class="close fileinput-exists"
                          data-dismiss="fileinput"
                          style="float: none"
                          >&times;</a
                        >
                      </div>
                    </div>
                  </div>

                  <div class="form-group">
                    <button
                      class="btn btn-info btn-block"
                      @click="registerUser"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="vld-parent">
            <loading
              :active.sync="isLoading"
              loader="dots"
              :can-cancel="true"
              :is-full-page="fullPage"
            ></loading>
          </div>
        </div>
      </section>
    </main>
  </section>
</template>

<script>
import Navbar from "@/views/Navbar.vue";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
// Init plugin

export default {
  components: {
    Navbar,
    Loading,
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      identities:["BVN", "NIN", "CAC", "TIN"],
      states: "",
      employees: "",
      state: "",
      lga_states: "",
      provider: {
        postalCode : "",
      },
    };
  },
  beforeMount() {
    this.user = JSON.parse(localStorage.getItem("user"));
  },
  methods: {
    getProvider() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/detailedProviderHmo/${this.$route.params.id}`)
        .then((response) => {
          this.provider = response.data.data[0];
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    fetchLga() {
      this.axios
        .get(`/api/v1/auth/lga/2669`)
        .then((response) => {
          this.lga_states = response.data.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    registerUser() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.isLoading = true;
      this.axios
        .post("/api/v1/auth/wallet/customer", {
          name: this.provider.agency_name,
          firstname: this.provider.firstname,
          lastname: this.provider.lastname,
          address1: this.provider.address1,
          email: this.provider.email,
          phone_number: '+234' + this.provider.phone_number,
          company_type: "company",
          id_type: this.provider.id_type,
          id_number: this.provider.id_number,
          state: "Kogi State",
          user_id: this.$route.params.id,
          dob: this.provider.dob,
          city: this.provider.user.localgovt.local_name,
          postalCode: this.provider.postalCode,
          country: 'Nigeria',
        })
        .then((response) => {
          console.log(response);

          this.$toasted.info("Wallet Created Successfully", {
            position: "top-center",
            duration: 3000,
          });

          this.$router.push(`/provider-${this.$route.params.id}`);
          this.isLoading = false;
         
        })
        .catch((error) => {
          console.log(error.response);
          this.isLoading = false;
          this.$breadstick.notify("Oops! something went wrong", {
            position: "top-right",
          });
        });
    },
    attachPic() {},
  },
  created() {
    this.getProvider();
  },
};
</script>
